require('../../brokerPensionPlanContribution.scss');
require('./pensionPlanExtraordinaryStep1.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
// @ components
const { AmountInput } = require('commonsComponents/amountInput');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { OKMessage } = require('commonsComponents/OKMessage');
const BrokerHireAndContributionsModal = require('components/broker/brokerHireAndContributionsModal/brokerHireAndContributionsModal');
// @ constants
const { FIRST_STEP } = require('constants/index');
const language = getLanguage();

class pensionPlanExtraordinaryStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.onHandleAmountInput = this.onHandleAmountInput.bind(this);
    }

    componentDidMount() {
        this.props.setPeriodicity(false);
    }

    onHandleAmountInput(value) {
        this.props.setOriginalAmount(value);
    }

    getAssociatedAccountBalance(accountNumber) {
        const { immAccounts } = this.props;
        const selectedAccount = immAccounts.get('byId').find(account =>
            account.getIn(['ibanComplex', 'codbban']) === accountNumber
        );

        return {
            amount: selectedAccount ? selectedAccount.getIn(['balances', 'availableBalance', 'amount']) : '',
            currency: selectedAccount ? selectedAccount.getIn(['balances', 'availableBalance', 'currency']) : ''
        };
    }

    createAmountInput(step1, errors, amount) {
        const negativeBalanceError = errors.get('negativeBalanceError');
        const minimumBalanceError = errors.get('minimumBalanceError');
        const contributionOverLimitsError = errors.get('contributionOverLimitsError');

        const amountError = errors.get('amountError');
        let errorMessage;
        if (amountError) {
            errorMessage = formatText('pensionPlanContribution-amountError');
        }
        if (negativeBalanceError || minimumBalanceError) {
            errorMessage = formatText('pensionPlanContribution-minimumBalanceError');
        }
        if (contributionOverLimitsError) {
            errorMessage = formatText('brokerHirePlansStep1-contributionOverLimitError');
        }
        const minimalText = this.createMinimalAmountLabel(amount);
        return (
            <div className="broker-pension-plan-contribution-step1__amount-input">
                <div className="hire-pension-plan-step1__disclaimer-container">
                    <OKMessage>
                        <FormattedText value="brokerHirePlansStep1-contributionBoxSubtitle" />
                    </OKMessage>
                </div>
                <AmountInput
                    min={0}
                    amount={step1.get('originalAmount')}
                    hideFocusZero={true}
                    callback={this.onHandleAmountInput}
                    error={amountError || negativeBalanceError || minimumBalanceError || contributionOverLimitsError}
                    errorMsg={errorMessage}
                    language={language}
                />
                {minimalText}
            </div>
        );
    }

    createMinimalAmountLabel(balance) {
        const plainAmountObject = getPlainAmountObject(balance);
        return (
            <div className="broker-pension-plan-contribution-step1__associated-cc-minimal">
                <FormattedText value="pensionPlanContribution-minimal" />
                <OneLineSymbolAmount
                    amountObject={plainAmountObject}
                    language={language}
                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
            </div>
        );
    }

    render() {
        const { immPensionPlanContribution, immBrokerPensionPlans } = this.props;
        const step1 = immPensionPlanContribution.getIn(['steps', FIRST_STEP]);
        const errors = step1.get('errors');
        const walletPlan = immPensionPlanContribution.get('pensionPlanFromWallet');
        const balanceForMinimal = {
            amount: immBrokerPensionPlans.getIn(['pensionPlan', 'contributionMinimumAmount']),
            currency: immBrokerPensionPlans.getIn(['pensionPlan', 'contributionMinimumAmountCurrency'])
        };
        let associatedAccountNumber = '';
        if (walletPlan) {
            const associatedAccount = walletPlan.get('cuentaAsociada');
            const office = associatedAccount.get('oficina');
            associatedAccountNumber = office.get('entidad') + office.get('oficina') + associatedAccount.get('digitodecontrol') + associatedAccount.get('numerodecuenta');
        }
        const truncatedAccountNumber = associatedAccountNumber.substr(associatedAccountNumber.length - 4);
        const balance = this.getAssociatedAccountBalance(associatedAccountNumber);
        const plainAmountObject = getPlainAmountObject(balance);
        const pensionPlanProvider = immBrokerPensionPlans.getIn(['pensionPlan', 'provider']);

        return (
            <article className="broker-pension-plan-contribution broker-pension-plan-contribution-step1">
                <header className="broker-pension-plan-contribution__header">
                    <FormattedText
                        value="pensionPlanContribution-step1Title"
                        className="broker-transfer-external-steps__title"
                    />
                </header>
                <section className="broker-pension-plan-contribution__content">
                    <div>
                        <BrokerHireAndContributionsModal pensionPlanProvider={pensionPlanProvider}/>
                        <p>
                            <FormattedText
                                value="pensionPlanContribution-step1AssociatedAccountLabel"
                                className="broker-pension-plan-contribution-step1__associated-account"
                            />
                        </p>
                        <p>
                            <span className="broker-pension-plan-contribution-step1__associated-account-name">
                                {immPensionPlanContribution.getIn([
                                    'pensionPlanFromWallet',
                                    'descripcion'
                                ])}
                            </span>
                            <span className="broker-pension-plan-contribution-step1__associated-account-name--extra">
                                {' '}...{truncatedAccountNumber} ({formatText('pensionPlanContribution-associatedAccountText')}
                                <OneLineSymbolAmount
                                    amountObject={plainAmountObject}
                                    language={language}
                                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />)
                            </span>
                        </p>

                        <h2 className="broker-pension-plan-contribution__subtitle">
                            <FormattedText value="pensionPlanContribution-step1AmountSection" />
                        </h2>

                        {this.createAmountInput(step1, errors, balanceForMinimal)}
                    </div>
                </section>
            </article>
        );
    }
}

pensionPlanExtraordinaryStep1.propTypes = {
    immPensionPlanContribution: PropTypes.object.isRequired,
    immBrokerPensionPlans: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    setOriginalAmount: PropTypes.func.isRequired,
    setPeriodicity: PropTypes.func.isRequired,
};

module.exports = pensionPlanExtraordinaryStep1;
